@tailwind base;
@tailwind components;
@tailwind utilities;

:host {
  display: block;
}

.no-scrollbar {
  /* For Firefox */
  scrollbar-width: none;
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}

.no-scrollbar::-webkit-scrollbar {
  display: none; /* For Chrome, Safari, and Opera */
}


@keyframes shareCopiedAnimation {
  0% {
    transform: scale(1) rotate(0deg);
  }
  40% {
    transform: scale(1.4) rotate(15deg);
  }
  80% {
    transform: scale(0.9) rotate(-10deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
  }
}
.animate-copied {
  animation: shareCopiedAnimation 1s forwards;
}


@keyframes fade-in {
  from {
    opacity: 0;
    transform: scale(0.25);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.animate-fade-in {
  animation: fade-in 0.5s forwards;
}
